import React, { useState } from "react";
import CustomModalLayout from "../../../web/Auth/CustomModalLayout";
import { Button } from "../../../../shadcn/components/ui/button";
import { Input } from "../../../../shadcn/components/ui/input";
import {
  getBidderOnboardingOfUser,
  updateBidderOnboardingDataAfterKYC,
} from "services/bidder";
import { useDispatch } from "react-redux";
import { setBidderOnboarding, setOnboarding } from "store";

interface NameUpdateModalProps {
  openNameModel: boolean;
  setOpenNameModel: any;
  profileName: string;
  onboardingData: any;
}

export default function NameUpdateModal({
  openNameModel,
  setOpenNameModel,
  profileName,
  onboardingData,
}: NameUpdateModalProps) {
  const dispatch = useDispatch();
  // const onboardingData = useSelector((state: any) => {
  //   return state.bidderAuth.onboarding;
  // });
  const [name, setName] = useState({
    name: profileName || "",
    error: "",
  });

  const [loading, setLoading] = useState(false);
  const handleProfileUpdate = async () => {
    setLoading(true);
    try {
      const trimmedName = name?.name.trim();

      if (!trimmedName) {
        setName((prev) => ({
          ...prev,
          error: "Name cannot be empty.",
        }));
        return;
      }

      if (/\d/.test(trimmedName)) {
        setName((prev) => ({
          ...prev,
          error: "Name should not contain numbers.",
        }));
        return;
      }

      const requestPayload: any = {
        name: trimmedName,
        authorized_person_name: trimmedName,
        user_can_update: false,
      };
      const res = await updateBidderOnboardingDataAfterKYC({
        uuid: onboardingData?.uuid,
        payload: requestPayload,
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      const onboarding: any = await getBidderOnboardingOfUser(
        onboardingData?.user_uuid
      );
      dispatch(setOnboarding(onboarding));
      dispatch(setBidderOnboarding(onboarding));
      setOpenNameModel(false);
      setLoading(false);
    } catch (error) {
      console.log("error:==========>>>>> ", error);
      setLoading(false);
    }
  };
  return (
    <CustomModalLayout
      open={openNameModel}
      onClose={() => setOpenNameModel(false)}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[420px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[443px]">
        <div className="flex flex-col gap-3">
          <div className="font-semibold text-lg text-brand-textBlack text-center">
            Update Profile Name
          </div>
          <div className="text-xs text-brand-textGrey text-center">
            Please update your profile name to exactly match the name on your
            official documents (e.g., PAN, Aadhaar) to ensure compliance and
            smooth processing of your auction participation.
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="text-lg font-semibold text-brand-textBlack">
              Profile Name
            </div>
            <div className="text-lg font-semibold text-brand-orange">
              {profileName}
            </div>
          </div>
          <div className="mt-4">
            <Input
              type="text"
              className="border border-brand-borderLightGray w-full py-2 px-4 text-sm tracking-wide font-sans text-brand-textBlack rounded"
              placeholder="Enter your Full Name"
              value={name?.name}
              onChange={(e: any) => {
                const value = e?.target?.value;
                const trimmedValue = value.trim();

                if (trimmedValue === "") {
                  setName({ name: value, error: "Please enter your name" });
                  return;
                }

                const isValid = /^[A-Za-z\s]+$/.test(trimmedValue);

                if (isValid) {
                  setName({ name: value, error: "" });
                } else {
                  setName({
                    name: value,
                    error: "Name should only contain alphabets and spaces.",
                  });
                }
              }}
            />
            {name?.error ? (
              <p className="mt-1 ml-2 text-sm text-red-500">{name?.error}</p>
            ) : null}
          </div>
        </div>
        <Button
          disabled={loading || name.error ? true : false}
          className=""
          onClick={handleProfileUpdate}
        >
          Update Profile Now
        </Button>
      </div>
    </CustomModalLayout>
  );
}
